// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","contactDiv":"Contact_contactDiv__Idpe5"};